import React, {Suspense, useEffect, useState} from 'react';
import {connect, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import SideNav from 'components/layout-components/SideNav';
import TopNav from 'components/layout-components/TopNav';
import Loading from 'components/shared-components/Loading';
import MobileNav from 'components/layout-components/MobileNav'
import HeaderNav from 'components/layout-components/HeaderNav';
import PageHeader from 'components/layout-components/PageHeader';
import Footer from 'components/layout-components/Footer';
import {Layout, Grid, Spin} from 'antd';
import navigationConfig from 'configs/NavigationConfig';
import {
    SIDE_NAV_WIDTH,
    SIDE_NAV_COLLAPSED_WIDTH,
    NAV_TYPE_SIDE,
    NAV_TYPE_TOP,
    DIR_RTL,
    DIR_LTR
} from 'constants/ThemeConstant';
import utils from 'utils';

import ApiService from "../services/ApiService"
import {updateOrg, updateAccess} from "../store/slices/authSlice"
import RestrictedAlert from "../components/permissions/RestrictedAlert";
import CallFab from "../components/CallFab";
import AppService from "../services/AppService";
import {ErrorBoundary} from "react-error-boundary";
import LayoutError from "./LayoutError";

const {Content} = Layout;
const {useBreakpoint} = Grid;

export const AppLayout = ({navCollapsed, navType, direction, children, dispatch}) => {

    const blankLayout = useSelector(state => state.theme.blankLayout);

    const access = useSelector(state => state.auth.access)

    const [loading, setLoading] = useState(true)

    const location = useLocation();

    useEffect(() => {
        reloadOrg()
    }, [])

    useEffect(() => {
        if (!loading) {
            if (AppService.init()) {
                uploadNotifToken()
            }
        }
    }, [loading])

    async function reloadOrg() {
        var res = await ApiService.get("/auth")
        console.log(res)
        if (res.success) {
            dispatch(updateOrg(res.data))
            dispatch(updateAccess(res.access))
            setLoading(false)
        }
    }

    async function uploadNotifToken() {
        const token = await AppService.getNotifToken()
        if (token) {
            await ApiService.post("/access/notif/register", {token: token, platform: window.APPPLATFORM})
        }
    }


    const currentRouteInfo = utils.getRouteInfo(navigationConfig, location.pathname)
    const screens = utils.getBreakPoint(useBreakpoint());
    const isMobile = screens.length === 0 ? false : !screens.includes('lg')
    const isNavSide = navType === NAV_TYPE_SIDE
    const isNavTop = navType === NAV_TYPE_TOP
    const getLayoutGutter = () => {
        if (isNavTop || isMobile) {
            return 0
        }
        return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH
    }


   if (loading) {
        return <Loading cover="page"/>;
    }

    const getLayoutDirectionGutter = () => {
        if (direction === DIR_LTR) {
            return {paddingLeft: getLayoutGutter()}
        }
        if (direction === DIR_RTL) {
            return {paddingRight: getLayoutGutter()}
        }
        return {paddingLeft: getLayoutGutter()}
    }

    if (blankLayout) {
        return (
            <Content>
                <Suspense fallback={<Loading cover="content"/>}>
                    {children}
                </Suspense>
            </Content>
        )
    }

    return (
        <Layout>
            <HeaderNav isMobile={isMobile}/>
            {(isNavTop && !isMobile) ? <TopNav routeInfo={currentRouteInfo}/> : null}
            <LayoutError>
                <Layout className="app-container">
                    {(isNavSide && !isMobile) ? <SideNav routeInfo={currentRouteInfo}/> : null}
                    <Layout className="app-layout" style={getLayoutDirectionGutter()}>
                        <div className={`app-content ${isNavTop ? 'layout-top-nav' : ''}`}>
                            <PageHeader display={currentRouteInfo?.breadcrumb} title={currentRouteInfo?.title}/>
                            <Content>
                                <Suspense fallback={<Loading cover="content"/>}>
                                    {children}
                                </Suspense>
                            </Content>
                        </div>


                        {!isMobile && <Footer/>}
                    </Layout>
                </Layout>
            </LayoutError>
            {isMobile && <MobileNav/>}
            {isMobile && access.id !== "DEMO_ACCESS_APPLE" && <CallFab/>}
        </Layout>
    )
}

const mapStateToProps = ({theme}) => {
    const {navCollapsed, navType, locale} = theme;
    return {navCollapsed, navType, locale}
};

export default connect(mapStateToProps)(React.memo(AppLayout));
